module.exports = __webpack_public_path__ + "static/media/about.8bced66c.svg";